module.exports = __webpack_public_path__ + "img/klue_text.b60aad34.svg";